<template>
  <v-card
    class="mx-auto"
  >
  
        <v-row dense>
            <v-col v-for="(item, i) in items" :key="i" cols="12">
                <v-card :color="item.color" dark>
                    <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                            <v-card-title class="headline" v-text="item.title"></v-card-title>

                            <v-card-subtitle v-text="item.artist"></v-card-subtitle>
                        </div>

                        <v-avatar class="ma-3" size="225" tile>
                            <v-img :src="item.src"></v-img>
                        </v-avatar>
                    </div>
                </v-card>
            </v-col>
        </v-row> 
         </v-card>

</template>
<script>
export default {
  data: () => ({
    items: [
      {
        color: "#1F7087",
        src: "https://cdn.vuetifyjs.com/images/cards/foster.jpg",
        title: "現地調査シート",
        artist: "現地調査をする際に使用する帳票です"
      },
      {
        color: "#952175",
        src: "https://cdn.vuetifyjs.com/images/cards/halcyon.png",
        title: "Halcyon Days",
        artist: "Ellie Goulding"
      },
      {
        color: "#952175",
        src: "https://cdn.vuetifyjs.com/images/cards/halcyon.png",
        title: "Halcyon Days",
        artist: "Ellie Goulding"
      }
    ]
  })
};
</script>>